export enum ReportType {
  Eligibility = 'Eligibility',
  Periodic = 'Periodic',
  Disturbance = 'Disturbance',
}
